<div class="flex">
  <div class="flex-1">
    <label
      class="input-main-label capitalize block mt-0 mb-1"
      for="conditionValue"
    >
      Condition value*
    </label>

    <mat-form-field
      class="input-classic w-full"
      appearance="outline"
    >
      <input
        id="conditionValue"
        type="text"
        (blur)="onTouched()"
        (ngModelChange)="onValueChange($event)"
        [disabled]="isDisabled()"
        [errorStateMatcher]="errorMatcher"
        [ngModel]="value()"
        matInput
        placeholder="Enter value"
      />
      <mat-error>Input is not valid</mat-error>
    </mat-form-field>
  </div>
</div>
